// Import extend function.
import Component from '../../../js/core/component.js';
import ajax from '../../../js/utilities/ajax/u-ajax.js';

class FormAjaxHandler extends Component {

	_defaultSettings () {
		return {
			debug: false,
		};
	}

	init (item) {
		let inputItems = item.querySelectorAll('[data-ajax-input]');
		let url = item.dataset.ajaxUrl + this._getQueryParams(inputItems);

		this._removeError(item);
		this._getData(url, item);
	}

	_getQueryParams (inputItems) {
		let params = '';

		for (let i = 0; i < inputItems.length; i++) {
			let value = inputItems[i].querySelector('input').value;

			params += `${i == 0 ? '?' : '&'}${inputItems[i].dataset.ajaxInput}=${value}`;
		}

		return params;
	}

	_getData (url, item) {
		ajax({
			method: 'GET',
			url: url,
			onSuccess: (response) => {
				response = JSON.parse(response);
				if (response.Status == 'success') {
					this._appendData(response);
				}
				else {
					this._appendError(item, response);
				}
			},
			onError: (reject) => {
				this._appendError(item, reject);
			}
		});
	}

	_appendData (data) {
		Object.keys(data).forEach((key) => {
			let output = document.querySelector(`[data-ajax-output="${key}"]`);
			let hiddenInput = document.querySelector(`[name="${key}"]`);

			if (output) {
				let outputEl = output.querySelector('dd span');
				outputEl.innerHTML = data[key];
				hiddenInput.value = data[key];
				this._triggerEvent(hiddenInput);
				output.style.display = '';
			}
		});
	}

	_appendError (item, error) {
		let errorMsg;

		if (typeof error.ErrorMessage == 'undefined') {
			errorMsg = 'Något gick fel vid hämtningen av data, vänligen försök igen vid ett senare tillfälle.';
		}
		else {
			errorMsg = error.ErrorMessage;
		}

		let errorEl = document.createElement('div');
		errorEl.classList.add('c-form-error');
		errorEl.setAttribute('role', 'alert');
		errorEl.setAttribute('aria-describedby', 'form-error-title');
		errorEl.innerHTML = `<h3 id="form-error-title" class="t-space-top-none">Något gick fel</h3> ${errorMsg}`;
		item.insertAdjacentElement('afterbegin', errorEl);
	}

	_removeError (item) {
		let error = item.querySelector('.c-form-error');
		if (error) {
			error.remove();
		}
	}

	_triggerEvent (el) {
		// Trigger change event
		let event = new CustomEvent('input');
		el.dispatchEvent(event);
	}
}

export default FormAjaxHandler;



// WEBPACK FOOTER //
// ./components/form-elements/form/c-form-ajax-handler.js